import { useAuthSession } from '@/hooks/AuthSessionHook'
import { useLoyaltyCampaign } from '@/hooks/LoyaltyCampaignHook'
import Icon from '../Icons'
import { Feedback, VelocityEarnCont, VirginEarnAmt } from '../OrderSummary.styles'
import { LoadingSpinner } from '@big-red-group/storefront-common-ui'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { useCart } from '@big-red-group/storefront-common-checkout'
import { centsToDollars } from '@big-red-group/storefront-common-checkout'

type VirginOrderSummaryProps = {
  velocityPointsType: string
  burnLoyaltyPoints: number
}

const OrderSummary = ({ velocityPointsType, burnLoyaltyPoints }: VirginOrderSummaryProps) => {
  const loyaltyCampaign = useLoyaltyCampaign()
  const { authenticated } = useAuthSession()
  const defaultProperties = useDefaultProperties()
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  const { isLoading, data: cart } = useCart('cart', baseUrl)

  if (isLoading || !cart) {
    return (
      <Feedback>
        <LoadingSpinner />
      </Feedback>
    )
  }

  return (
    <div>
      {velocityPointsType === 'earn' && (
        <VelocityEarnCont>
          <VirginEarnAmt>
            <Icon name="velocityPointsWhite" height={15} width={15} /> +{' '}
            {Math.ceil(loyaltyCampaign?.pointsPerDollar! * centsToDollars(cart?.payableTotal))} Velocity Points
          </VirginEarnAmt>
        </VelocityEarnCont>
      )}
      {velocityPointsType === 'burn' && authenticated && (
        <VelocityEarnCont>
          <VirginEarnAmt>
            <Icon name="velocityPointsWhite" height={15} width={15} /> -{' '}
            {Math.round(burnLoyaltyPoints).toLocaleString()} Velocity Points
          </VirginEarnAmt>
        </VelocityEarnCont>
      )}
    </div>
  )
}

export default OrderSummary
